import {
  IRequestPixPaymentParams,
  IRequestPixPaymentResponse,
  IRequestPixPaymentResponseRaw,
} from '../types'
import { RequestScheduleAttendancePixMapper } from './RequestScheduleAttendancePixMapper'

export class PixPaymentMapper {
  static toPersistence(data: IRequestPixPaymentParams) {
    const requestScheduleAttendancePixMapper =
      RequestScheduleAttendancePixMapper.toPersistence(data)

    return {
      pixRequest: {
        valor: data.pixRequest.value,
        conselhoIsCRP: data.pixRequest.isCRP,
      },
      modoAtendimento: data.mode,
      ...(data.mode === 'AGENDADO'
        ? { atendimentoAgendado: requestScheduleAttendancePixMapper }
        : {
            atendimentoImediato: requestScheduleAttendancePixMapper.atendimento,
          }),
    }
  }

  static toDomain(
    data: IRequestPixPaymentResponseRaw,
  ): IRequestPixPaymentResponse {
    return {
      chargeId: data.charge_id,
      lastTransaction: {
        id: data.last_transaction.id,
        pixProviderTid: data.last_transaction.pix_provider_tid,
        qrCode: data.last_transaction.qr_code,
        qrCodeUrl: data.last_transaction.qr_code_url,
        expiresAt: data.last_transaction.expires_at,
        transactionType: data.last_transaction.transaction_type,
        gatewayId: data.last_transaction.gateway_id,
        amount: data.last_transaction.amount,
        status: data.last_transaction.status,
        success: data.last_transaction.success,
      },
    }
  }
}
